import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/locations";
import { selectSearchText } from "../../../store/locations/selectors/selectSearchText";

export const SearchTextInput: React.FC = () => {
  const dispatch = useDispatch();
  const value = useSelector(selectSearchText);
  return (
    <IonSearchbar
      value={value}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
      }}
      debounce={900}
      placeholder={"Buscar instalación"}
    />
  );
};
